import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { Layout } from 'ts/types/Layout'
import { formatter } from 'utils'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import LayoutAddPage from './LayoutAddPage'
import { useTrader } from 'context/TraderTypeContext';

const columns: Column<Layout>[] = [
  {
    Header: 'ID',
    accessor: 'layoutId'
  },
  {
    Header: 'Active',
    accessor: 'flActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Layout Name',
    accessor: 'name'
  },
  {
    Header: 'Columns',
    accessor: 'numberOfColumns',
    Cell: ({ value }) => <div className="text-center">{value}</div>
  },
  {
    Header: 'Rows',
    accessor: 'numberOfRows',
    Cell: ({ value }) => <div className="text-center">{value}</div>
  },
  {
    Header: 'Last Modified',
    accessor: 'lastModified',
    Cell: ({ value }) => formatter.dateTime(value)
  }
]

const LayoutPage = () => {
  const Url = GetUrls();
  const { traderId } = useTrader();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.layout.toString()}
    url={Url.layout(traderId)}
    modalChild={<LayoutAddPage />}
  />
)}

export default LayoutPage
